import React, { useEffect, useState } from "react";
import SecondaryHeading from "../../../utils/SecondaryHeading/SecondaryHeading";
import MentorSlider from "./Sliders/MentorSlider";
import { MentorsSlider } from "../../../Constant";
import PrimaryBtn from "../../../utils/PrimaryBtn/PrimaryBtn";
import axios from "axios";
import Loading from "../../../utils/Loader/Loading";
import Timer from "../../../main/Timer/Timer";

const Mentors = ({ id }) => {
  let [state, setState] = useState([]);
  let [isLoading, setIsLoading] = useState(true);
  let [isError, setIsError] = useState(false);

  useEffect(() => {
    let fetchCards = async () => {
      try {
        let response = await axios.get(
          `https://vercel-deployment-w4ja.onrender.com/api/get_mentors/${id}`
        );
        setState(response.data.data);
      } catch (error) {
        console.log(error);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };
    fetchCards();
  }, []);

  return (
    <div>
      {isLoading && (
        <div className="my-50 flex justify-center items-center h-screen">
          <Loading />
        </div>
      )}
      {!isLoading && !isError && state.length !== 0 && (
        <section className="max-sm:px-5">
          <div className="max-w-7xl m-auto mt-16 ">
            <div className="flex justify-center mb-10">
              <SecondaryHeading>Learn From Our Mentors</SecondaryHeading>
            </div>
            <div className=" m-auto  max-w-6xl relative ">
              <MentorSlider data={state} />
            </div>
          </div>
          <Timer />
          <div className="flex justify-center mt-4">
            <PrimaryBtn>Meet Your Mentor</PrimaryBtn>
          </div>
        </section>
      )}
      {isError && "Error Occurred"}
    </div>
  );
};

export default Mentors;
